import { forceReloadTo } from './hardNavigation'

const handleResponseError = (message, error) => {
    if (error.data) {
        if (error.data.detail) {
            message.error(`${error.status} ${error.data.detail}`)
        } else {
            message.error(`${error.status} ${error.data.errors}`)
        }
    } else {
        message.error(error.message)
    }
}

const redirectToLogin = () => {
    localStorage.removeItem("loginState")
    forceReloadTo("#/")
}

const handleResponse = async (url, response, processResponse=true) => {
    if (!response.ok) {
        return response.json().then(errorData => {
            console.log(`${url} 请求错误，请重试`);
            console.log(`${url} errorData = `, errorData);

            // 创建错误对象并附加状态码和错误数据
            const error = new Error(`请求错误，请重试 (Status: ${response.status})`);
            error.status = response.status; // 将状态码添加到错误对象
            error.data = errorData; // 将后端响应的错误信息添加到错误对象

            throw error;
        });
    } else {
        // console.log(`${url} data = `, response.json());
        return processResponse ? response.json() : response
    }
};

const createController = () => {
    return new AbortController();
};

// 封装 fetch 请求，自动处理 cookie 刷新逻辑
const fetchWithCookieRefresh = async (url, options, { retryCount = 1, timeout = 60000, processResponse = true } = {}) => {
    let timeoutId; // 用于存储超时定时器的 ID

    // 创建一个可以取消的 fetch 请求
    const fetchPromise = new Promise((resolve, reject) => {
        fetch(url, { ...options }).then(resolve).catch(reject)
    })

    // 创建用于超时的 Promise
    const timeoutPromise = new Promise((_, reject) => {
        timeoutId = setTimeout(() => {
            console.log("timeout request error")
            reject(new Error('Request timed out'))
        }, timeout)
    })

    try {
        // 使用 Promise.race 来同时处理超时和 fetch 请求
        const response = await Promise.race([
            fetchPromise,
            timeoutPromise
        ]);

        clearTimeout(timeoutId) // 清除超时定时器

        // 当响应状态码是 401 时，检查 body 中的值
        if (response.status === 401) {
            const responseBody = await response.json(); // 假设响应内容是 JSON 格式
            // 检查响应体是否有特定的 detail 值
            if (responseBody.detail === 'Signature has expired' && retryCount > 0) {
                await refreshCookie(); // 刷新 cookie
                return fetchWithCookieRefresh(url, options, {retryCount: retryCount - 1, timeout: timeout, processResponse: processResponse}); // 重新发送请求
            } else {
                // 如果认证没通过，将删除相关登录信息，回到登录页
                // responseBody.detail === 'Signature verification failed'
                redirectToLogin()
            }
        }

        // 返回原始响应对象
        return await handleResponse(url, response, processResponse)
    } catch (error) {
        clearTimeout(timeoutId)
        console.error('Fetch with cookie refresh failed:', error)
        throw error
    }
}

// 处理 cookie 刷新逻辑的函数
const refreshCookie = async () => {
    try {
        const refreshResponse = await fetch('/api/account/refresh', {
            method: 'POST',
            // credentials: 'include' // 如果你的cookie是HTTP-only，确保包含这个选项
        })
        if (refreshResponse.ok) {
            console.log("已刷新");
        } else if (refreshResponse.status === 401) {
            redirectToLogin()
        } else {
            throw new Error('Cookie refresh failed')
        }
    } catch (error) {
        console.error('Error refreshing cookie:', error)
        throw error
    }
}

export {
    fetchWithCookieRefresh,
    createController,
    handleResponseError,
    redirectToLogin,
}
